function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(18)",
  stroke: "#F4F4F4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 12,
  height: 38,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 60.5,
  y: 0.5,
  width: 12,
  height: 38,
  rx: 6
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M30.5 20.5h47M.5 48.5h107.005"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42 68.547C44.825 64.605 48.322 62 54.845 62 61.435 62 65 65.808 65 70.217c0 9.286-14.123 9.687-14.123 18.706 0 1.737.807 3.474 2.96 5.077M54 105c-1.09 0-2-.923-2-2.03 0-1.047.91-1.97 2-1.97 1.09 0 2 .923 2 1.97 0 1.107-.91 2.03-2 2.03zM18.664 26.003a9.5 9.5 0 1011.777.083M78.584 26.066a9.5 9.5 0 1011.99.129",
  stroke: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.355 20.5H103.5a5 5 0 015 5v89a5 5 0 01-5 5h-98a5 5 0 01-5-5v-89a5 5 0 015-5h13.298",
  stroke: "#FFF"
}));

function SvgCalendarExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 120,
    viewBox: "0 0 109 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarExpired);
export default __webpack_public_path__ + "static/media/CalendarExpired.5a5fd36b.svg";
export { ForwardRef as ReactComponent };